import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mode-toggle',
  templateUrl: './mode-toggle.component.html',
  styleUrls: ['./mode-toggle.component.scss']
})
export class ModeToggleComponent {
  @Output() modeChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() disabled!: any;
  isRemoteMode: boolean = true; // Default to Local mode

  // Toggle the mode
  toggleMode() {
    this.isRemoteMode = !this.isRemoteMode;
    this.modeChanged.emit(this.isRemoteMode);
  }

  // Get the selected mode
  get selectedMode(): string {
    return this.isRemoteMode ? 'Remote' : 'Local';
  }
}